import { MainContainer } from "../main";
import { LoadingOverlay } from "components/common";
import {
  ContentContainer,
  Header,
  SelectProduct,
  OrderNotes,
  ImpressionsSelect,
  SelectArches,
  FilesUpload,
  Footer,
  VerificationWindow,
  CompleteArchWarning,
  CompleteCaseWarning,
  HeaderSubTitle,
  MeditLink,
} from "./components";
import Stack from "@mui/material/Stack";
import { useAppDispatch, useAppSelector } from "hooks/redux";
import { actions, selectors } from "store/continuationOrderCreate";
import {
  FormControl,
  FormControlLabel,
  Grid,
  MenuItem,
  Radio,
  RadioGroup,
  Select,
} from "@mui/material";

import { useAtom } from "jotai";
import { atomWithStorage } from "jotai/utils";
import useGetScannerList from "hooks/useGetScannerList";
import LastImpression from "./components/LastImpression";
import { useEffect } from "react";
type choosenFileType = "physical" | "digital";
const choosenType = atomWithStorage<choosenFileType>(
  "ContinuationOrderType",
  "digital"
);
const existingFile = atomWithStorage("ContinuationOrderUseExistingFile", true);

export const ContinuationOrderCreateContainer = () => {
  const [choosenFileType, setFileType] = useAtom(choosenType);
  const [useExisting, setUseExisting] = useAtom(existingFile); //Todo: remove jotai for this just use redux + localstorage

  const dispatch = useAppDispatch();
  const {
    isSaving,
    showVerification,
    previousOrder,
    caseInfo,
    useExistingModel,
  } = useAppSelector(selectors.getAllInfoSelector);
  useEffect(() => {
    dispatch(actions.setSendExistingModel(useExisting));
  }, []);
  const needVKFiles = useAppSelector(selectors.needVKFilesSelector);
  const IsScannerSelected = useAppSelector(
    (state) => state.newOrder.useMeditLink
  );
  const closeHandler = () => {
    dispatch(actions.setShowVerification(false));
  };
  const { scannerlist, selectedScanner, setSelectedScanner } =
    useGetScannerList();

  return (
    <MainContainer>
      <ContentContainer>
        <LoadingOverlay
          text="Please, wait until data(files) saving will have finished"
          open={isSaving}
        />
        {previousOrder && (
          <VerificationWindow
            withFiles={needVKFiles}
            orderInfo={previousOrder}
            open={showVerification}
            closeHandler={closeHandler}
          />
        )}
        <CompleteCaseWarning />
        <CompleteArchWarning />
        <Header />
        <Grid container>
          <Grid item xs={7}>
            <HeaderSubTitle />
            <Stack mt={3} spacing={3}>
              <SelectProduct />
              <SelectArches />
            </Stack>
          </Grid>
        </Grid>
        <Grid container>
          <Stack mt={3} spacing={3}>
            <Grid item xs={12}>
              <FormControl>
                {/* NEW COMP */}
                <RadioGroup
                  onChange={(e) => {
                    setUseExisting(e.target.value === "true");
                    dispatch(
                      actions.setSendExistingModel(e.target.value === "true")
                    );
                  }}
                  value={useExistingModel}
                  name="impressionSource"
                >
                  <FormControlLabel
                    value={true}
                    control={<Radio />}
                    label="Use existing impressions"
                  />
                  <FormControlLabel
                    value={false}
                    control={<Radio />}
                    label="Send new impressions"
                  />
                </RadioGroup>
              </FormControl>
            </Grid>

            {useExistingModel ? (
              <LastImpression caseId={caseInfo?.id} />
            ) : (
              <>
                {/* NEW COMP */}
                <FormControl sx={{ width: 1 / 2, mt: 2 }}>
                  <Select
                    labelId="impType"
                    id="impTypeSelect"
                    defaultValue={choosenFileType}
                    displayEmpty
                    size="small"
                    inputProps={{ "aria-label": "Without label" }}
                    onChange={(e) => {
                      setFileType(e.target.value as choosenFileType);
                    }}
                    sx={{}}
                  >
                    <MenuItem value={"digital"}>Digital Files</MenuItem>
                    <MenuItem value={"physical"}>
                      Physical PVS Impressions
                    </MenuItem>
                  </Select>
                </FormControl>
                {choosenFileType === "physical" && (
                  <Grid item xs={12}>
                    <ImpressionsSelect />
                  </Grid>
                )}
                {choosenFileType === "digital" && (
                  <>
                    <Grid item xs={12}>
                      {/* MODIFY COMP */}
                      <MeditLink />
                      {IsScannerSelected && (
                        <Select
                          labelId="scannerType"
                          id="scannerTypeSelect"
                          defaultValue={selectedScanner}
                          size="small"
                          inputProps={{ "aria-label": "Without label" }}
                          onChange={(e) => {
                            setSelectedScanner(
                              e.target.value as choosenFileType
                            );
                          }}
                          sx={{
                            width: `${(selectedScanner?.length ?? 10) + 5}ch`,
                          }}
                        >
                          {scannerlist.map((brand) => (
                            <MenuItem key={brand} value={brand}>
                              {brand}
                            </MenuItem>
                          ))}
                        </Select>
                      )}
                    </Grid>

                    <Grid item xs={12} style={{ marginTop: -48 }}>
                      <FilesUpload />
                    </Grid>
                  </>
                )}
              </>
            )}
            <Grid item xs={12} lg={12}>
              <OrderNotes />
            </Grid>
          </Stack>
        </Grid>
        <Footer />
      </ContentContainer>
    </MainContainer>
  );
};
